import React, { memo } from "react";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
   footer: {
   // backgroundColor: "whitesmoke",
    height: "10vh", 
  //  display: "flex",
  //  flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
   //  color: "white"
  }  
}));

const Footer = () => {
  const classes = useStyles();
  return (
    <AppBar position="static" color="primary" className={classes.footer}>
      <Toolbar>
        <Typography variant="body2">
          {"Copyright © "} HealthLogic {new Date().getFullYear()}
        </Typography>
      </Toolbar>
    </AppBar>
  );
};
export default Footer;
